import { render, staticRenderFns } from "./WhiteboardControl.vue?vue&type=template&id=36a2322c&scoped=true&"
import script from "./WhiteboardControl.vue?vue&type=script&lang=js&"
export * from "./WhiteboardControl.vue?vue&type=script&lang=js&"
import style0 from "./WhiteboardControl.vue?vue&type=style&index=0&id=36a2322c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2322c",
  null
  
)

export default component.exports